import React from 'react';
import pad from 'pad';
import moment from 'moment';
import Rating from './Rating';
import './css/Episode.css';

export default function Episode(props) {
  let link = `${process.env.REACT_APP_VIDEO_BASE}/The.Simpsons.S${pad(2, props.data.season.toString(), '0')}E${pad(2, props.data.episode.toString(), '0')}.mp4`;

  let yearsAgo = null;
  if (props.today) {
    yearsAgo = (
      <span>
        ,&nbsp;
        <span className="episode--years-ago">
          {moment().diff(props.data.airDate, 'years')} years ago
        </span>
      </span>
    );
  }

  return (
    <div className={`episode ${props.today ? 'today' : ''}`}>
      <span>S{props.data.season}E{props.data.episode}, </span>
      <span>
        {moment(props.data.airDate).format('Do MMMM YYYY')}
        {yearsAgo}
      </span>
      <div className="episode--heading">
        <h2 className="episode--title">
          <a href={link}>
            {props.data.name}
          </a>
        </h2>
        <div className="episode--rating">
          <Rating rating={props.data.normalRank * 4 + 1} />
        </div>
      </div>
      <table className="episode--container">
        <tbody>
          <tr>
            <td className="episode--thumbnail">
              <a href={link}>
                <img src={props.data.thumbnailUrl} className="episode--thumbnail--image" alt="Episode thumbnail" />
              </a>
            </td>
            <td className="episode--detail">
              <p>{props.data.description}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/Episode.js